import { formatDateDual } from '../../utils/calendar';

// App-wide standard (Pass B): a FULL date shown BS-primary with a muted AD secondary.
// Renders e.g. "2083 Asar 12 · 28 Jun 2026" with the AD half in text-muted so it's visually
// subordinate, never competing with the BS value. Empty date → "—".
//
//   <DualDate date={session.date} />
//   <DualDate date={p.paidDate} className="text-xs text-muted" />   // AD stays muted inside
//
// `separator` defaults to a middot; pass "" for none. On a space-tight line pass adHidden to
// drop the AD half (BS-only) rather than crowd — the caller decides.
export default function DualDate({ date, className = '', separator = ' · ', adHidden = false }) {
  const { primary, secondary } = formatDateDual(date);
  return (
    <span className={className}>
      {primary}
      {!adHidden && secondary && (
        <span className="text-muted">{separator}{secondary}</span>
      )}
    </span>
  );
}
